import * as tus from 'tus-js-client';
import { action, extendObservable } from 'mobx';

class VimeoVideoUploadService {
  constructor() {
    extendObservable(this, {
      isOpen: false,
      uploadPercentage: 0,
    });
  }

  init = action(() => {
    this.isOpen = false;
    this.uploadPercentage = 0;
  });

  handleUpload = action((file, uploadUrl) => {
    this.isOpen = true;
    return new Promise((resolve, reject) => {
      const uploader = new tus.Upload(file, {
        uploadUrl: uploadUrl,
        onProgress: this.handleUploadProgress,
        onError: function (error) {
          reject(error);
        },
        onSuccess: function () {
          resolve();
        },
      });
      uploader.start();
    });
  });

  handleUploadProgress = action((bytesUploaded, bytesTotal) => {
    const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
    this.uploadPercentage = percentage;
    if (percentage >= 100) {
      this.isOpen = false;
    }
  });
}

const vimeoVideoUploadService = new VimeoVideoUploadService();

export default vimeoVideoUploadService;
